<div class="off-canvas" [ngClass]="{ 'open': active, 'closable' : isClosable }">
    <div class="off-canvas-overlay" (click)="overlayClicked($event)"></div>
    <div class="off-canvas-content" (click)="canvasClicked($event)">
        <div class="header">
            <div class="header-icon" (click)="close();"></div>
        </div>
        <ng-template view-ref>
        </ng-template>
    </div>
</div>
